"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpeakerCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _speakerCardUtils = require("./speakerCardUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SpeakerCard = props => {
  const {
    speakerId,
    imageUrl,
    name,
    jobTitle
  } = props;
  const urlName = (0, _speakerCardUtils.nameToPath)(name);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "con-speaker-card",
    id: "speaker-".concat(speakerId)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-speaker-card__inner"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "".concat(urlName, "/").concat(speakerId),
    className: "con-link__readmore"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-image__container",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-speaker-introduction"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "con-heading__m--centered"
  }, name), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__xs--centered"
  }, jobTitle)))));
};
exports.SpeakerCard = SpeakerCard;
SpeakerCard.propTypes = {
  speakerId: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  name: _propTypes.default.string,
  jobTitle: _propTypes.default.string
};